<template>
    <div class="c-connections__wrap"
        :data-component-name="$options.name"
    >
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
        <div class="c-connections-list__search">
            <Input
                type="text"
                name="searchListAll"
                placeholder="Rechercher / filtrer"
                v-model="connections.searchListAll"
                input-class="-search-input"
                iconButtonPrefix="search"
            />
        </div>
        <div class="c-connections-list__wrap">
            <div class="c-connections-list">
                <div
                    v-for="item in orderedAll"
                    v-bind:key="item.id"
                    class="c-connections-list__item"
                    :class="{ 'is-hidden': item.name.toLowerCase().search(connections.searchListAll.toLowerCase()) === -1 || isInCurrent(item) }"
                >
                    <div class="c-connections-list__item__text">
                        <span>{{ item.name }}</span>
                    </div>
                    <div class="c-connections-list__controls">
                        <button class="o-button -add -sm"
                            @click.prevent="addConnection(item, $event)"
                        >
                            Ajouter
                            <q-icon name="double_arrow" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="c-connections-list__wrap">
            <div class="c-connections-list">
                <div
                    v-bind:key="item.id"
                    v-for="item in orderedCurrents"
                    class="c-connections-list__item"
                    :class="{ 'is-hidden': item.name.toLowerCase().search(connections.searchListAll.toLowerCase()) === -1 }"
                >
                    <div class="c-connections-list__item__text">
                        <span>{{ item.name }}</span>
                    </div>
                    <div class="c-connections-list__item__rating">
                        <span
                            class="rating"
                            v-if="connections.useRating"
                        >
                            <span
                                class="o-button-rating"
                                :class="{ 'checked': item.rating && Math.round(item.rating/20)*20>=20 }"
                                @click.prevent="setRating(item, 20, $event)"
                            ></span>
                            <span
                                class="o-button-rating"
                                :class="{ 'checked': item.rating && Math.round(item.rating/20)*20>=40 }"
                                @click.prevent="setRating(item, 40, $event)"
                            ></span>
                            <span
                                class="o-button-rating"
                                :class="{ 'checked': item.rating && Math.round(item.rating/20)*20>=60 }"
                                @click.prevent="setRating(item, 60, $event)"
                            ></span>
                            <span
                                class="o-button-rating"
                                :class="{ 'checked': item.rating && Math.round(item.rating/20)*20>=80 }"
                                @click.prevent="setRating(item, 80, $event)"
                            ></span>
                            <span
                                class="o-button-rating"
                                :class="{ 'checked': item.rating && Math.round(item.rating/20)*20>=100 }"
                                @click.prevent="setRating(item, 100, $event)"
                            ></span>
                        </span>
                    </div>
                    <span class="c-connections-list__controls">
                        <button class="o-button -delete -warning -sm" type="button"
                            @click.prevent="removeCurrent(item, $event)"
                        >
                            <SvgIcon name="close" />
                        </button>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import orderBy from "lodash/orderBy";

    export default {
        name: 'connections',
        props: [
            "connections",
        ],
        methods: {
            addConnection(item, e) {
                e.preventDefault();
                item.rating=0;
                this.$emit('add-connection', item)
                return false;
            },
            removeCurrent(item, e) {
                e.preventDefault();
                this.$emit('remove-connection', item)

                // this.connections.currents = this.connections.currents.filter(function(current){
                //     return current.id !== item.id;
                // });
            },
            isInCurrent(item){
                let isInCurrent=false;
                this.connections.currents.forEach(function(current){
                    if( current.id == item.id ) isInCurrent=true;
                });
                return isInCurrent;
            },
            setRating(item, rating, e){
                e.preventDefault();
                if(item.rating==rating) rating=rating-20;
                this.$emit('set-rating', {item: item, rating: rating})
            }
        },
        computed: {
            orderedCurrents: function () {
                return orderBy(this.connections.currents, [item => item.name.toLowerCase()])
            },
            orderedAll: function () {
                return orderBy(this.connections.all, [item => item.name.toLowerCase()])
            },
        }

    }
</script>
<style lang="scss">
    @import "@/scss/components/globals/Connections.scss";
</style>
